import { useMutation } from '@tanstack/react-query';

import { ResetPasswordSetNewPasswordData } from '../../../../types/requests';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postResetPassword } from '../../requests/postResetPassword';

type ResetPasswordVariables = {
  data: ResetPasswordSetNewPasswordData;
  headers?: Record<string, string>;
};

export const useResetPassword = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({ data, headers }: ResetPasswordVariables) =>
      postResetPassword(constructPost, data, headers),
  });
  return { resetPassword: mutateAsync, ...rest };
};
